import React, { Component } from 'react';
import classNames from 'classnames';
import styles from './MuseumItem.module.scss';
import { withTranslation, WithTranslation } from 'next-i18next';
import { IMuseumResource } from '@/interfaces/IMuseumResource';
import { MuseumFilterTypes } from '@/enums/MuseumFilterTypes';
import ImageLoader from '@/components/features/posts/ImageLoader/ImageLoader';
import { getImageUrl, size } from '@/utils/attachment';
import { formatExhibitionDuration } from '@/utils/museum-date';
import { ellipsis } from '@/utils/string-util';

interface IMuseumItemProps extends WithTranslation {
	data: IMuseumResource;
	className?: string;
}

class MuseumItem extends Component<IMuseumItemProps> {
	render() {
		const { data, className, t } = this.props;

		const museumClassNames = classNames(styles.museum, className);

		const footerClassNames = classNames(styles.museumFooter);

		const statusClassNames = classNames(styles.museumStatus, {
			[styles.museumStatusCurrent]: data.status === MuseumFilterTypes.CURRENT,
			[styles.museumStatusPast]: data.status === MuseumFilterTypes.PAST,
			[styles.museumStatusUpcoming]: data.status === MuseumFilterTypes.UPCOMING,
		});

		const linkClassNames = classNames(styles.museumLink, {
			[styles.museumLinkPast]: data.status === MuseumFilterTypes.PAST,
			[styles.museumLinkCurrent]: data.status === MuseumFilterTypes.CURRENT,
			[styles.museumLinkUpcoming]: data.status === MuseumFilterTypes.UPCOMING,
		});

		const linkText = 'learn-more';

		return (
			<div key={data.id} className={museumClassNames}>
				<div className={styles.museumWrapper}>
					<div className={styles.museumMedia}>
						<ImageLoader
							src={getImageUrl(data.image, size.MEDIUM)}
							preloader={getImageUrl(data.image, size.PRELOADER)}
							className={styles.museumImage}
						/>
					</div>
					<div className={styles.museumHeader}>
						<div className={statusClassNames}>{t(data.status as any)}</div>
						<div className={styles.museumLocation}>{data.title}</div>
						<div className={styles.museumDate}>{formatExhibitionDuration(data)}</div>
					</div>
					<div className={styles.museumContent}>
						<div className={styles.museumDesc}>
							{data.location}
							<br />
							{ellipsis(data.description)}
						</div>
					</div>
					<div className={footerClassNames}>
						{data.link ? (
							<a className={linkClassNames} href={data.link}>
								{t(linkText)}
							</a>
						) : null}
					</div>
				</div>
			</div>
		);
	}
}

export default withTranslation()(MuseumItem);
